import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 35
  },
  field: {
    margin: '10px 0'
  },
  countryList: {
    ...theme.typography.body1
  },
  form: {
    width: '100%'
  },
  submit: {
    margin: 0
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/components/LoginForm/styles.js